export default __webpack_public_path__ + "static/media/sky.ffca51f5.png";